import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const getCompany = async (id) => axios.get(
  `${baseUrl()}r/companies/${id}/`,
);

export const companyTable = async (search, page = 1, pageSize = 50) => axios.get(
  `${baseUrl()}r/companies?page=${page}&pageSize=${pageSize}${search ? `&search=${search}` : ''}`, { withCredentials: true },
);

export const companyCreate = async (payload) => axios.post(
  `${baseUrl()}r/companies/`, payload, { withCredentials: true },
);

export const companyUpdate = async (payload) => axios.patch(
  `${baseUrl()}r/companies/${payload.id}/`, payload, { withCredentials: true },
);

export const companyDelete = async (id) => axios.delete(
  `${baseUrl()}r/companies/${id}/`,
);
